import { useCookies } from "react-cookie";
import Constants from "../../utils/Constants";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export const useProtectedRouteLogin = function () {
  const navigate = useNavigate();

  const [cookies] = useCookies([
    "userId",
    "userContract",
    "date",
    "authList",
    "token",
    "maxage",
  ]);

  // トークン作成処理
  const createToken = async (key: string) => {
    // utf-8のuint8Arrayにエンコード
    const msgUint8 = new TextEncoder().encode(key);
    // ハッシュ化
    const digest = await window.crypto.subtle.digest("SHA-256", msgUint8);
    // バイト列に変換
    const hashArray = Array.from(new Uint8Array(digest));
    // 16進文字列に変換
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
    return hashHex;
  };

  // トークン一致チェック
  const checkToken = useCallback((check: string) => {
    let token = cookies.token;
    if (check !== token) {
      return navigate(Constants.NAVI_LOGIN);
    }
  }, [cookies.token])

  // Cookie値チェック
  const checkCookie = useCallback(() => {
    // データが存在していない場合
    if (!!!cookies.userId) {
      // undefined/null/空文字
      return false;
    }
    if (!!!cookies.userContract) {
      // undefined/null/空文字
      return false;
    }
    // 日付
    if (!!!cookies.date) {
      return false;
    }
    // 権限CDリスト
    if (!!!cookies.authList) {
      return false;
    }
    // トークン
    if (!!!cookies.token) {
      return false;
    }
    // 有効期限
    if (!!!cookies.maxage) {
      return false;
    }
    // 日付不正チェック
    let maxagedate = new Date(cookies.maxage);
    if (isNaN(maxagedate.getTime())) {
      return false;
    }

    return true;
  }, [cookies.authList, cookies.date, cookies.maxage, cookies.token, cookies.userContract, cookies.userId])

  // 有効日時チェック
  const checkMaxage = useCallback(() => {
    // 現在日付
    let date = new Date();
    // 有効期限
    let maxagedate = new Date(cookies.maxage);
    // 比較
    let maxage = date.getTime() <= maxagedate.getTime() ? true : false;

    return maxage;
  }, [cookies.maxage])

  // ログインチェック
  const getAuth = useCallback(() => {
    let loggedIn = false;

    // Cookie値チェック
    if (!checkCookie()) {
      // エラー
      return loggedIn;
    }
    //有効期限チェック
    if (!checkMaxage()) {
      // エラー
      return loggedIn;
    }

    // トークンチェック
    let key: string =
      cookies.date +
      Constants.LOGIN_TOKEN_KEY +
      cookies.authList +
      cookies.userContract;

    // トークン作成
    createToken(key).then((hash) => checkToken(hash));

    loggedIn = true;

    return loggedIn;
  },[])

  // ログインチェック
  let loggedIn = getAuth();
  return loggedIn;

};

export default useProtectedRouteLogin;
